import Gator from 'gator';
import jump from 'jump.js';

Gator(document).on('keypress', '[role="button"]', function(event) {
    if (event.charCode == 13) {
        // Enter
        this.click();
    }
});

Gator(document).on('click', 'a[href^="#"].-jump', function(event) {
    event.preventDefault();
    jump(this.getAttribute('href'));
});

// Enable reset radios
[...document.querySelectorAll('.-js-reset[name]')].forEach(element => {
    let active = false;

    Gator(document).on('click', `.-js-has-reset[name="${element.name}"]`, function() {
        if (active == this) {
            element.click();
            active = false;
        } else {
            active = this;
        }
    });
});
